'use client';

import { createContext, useContext } from 'react';

import type { ParagraphCommentUi } from '../../types/lexical.types';

export const ParagraphCommentUiContext = createContext<ParagraphCommentUi | null>(null);

export function useParagraphCommentUiContext() {
  return useContext(ParagraphCommentUiContext);
}
